export default {
  subject: 'Notification Title',
  notification_time: 'Notification Time',
  type: 'Notificetion Type',
  unread: 'Unread',
  all: 'All',
  mark_all_read: 'Mark all as read ({count})',
  notification_content: 'Notification Content',
  attachment: 'Attachment',
  view_all: 'View all',
  no_notification: 'You have no notification yet.'
}
